import React, { useEffect, useState } from 'react';
import { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import GoodsCard from './GoodsCard';

const getCategoryList = ({ list }) => {
  const categoryList = [];

  for (const goods of list) {
    if (goods.categoryTags) {
      const tags = goods.categoryTags.split(',').map((tag) => tag.trim());

      for (const tag of tags) {
        if (categoryList.findIndex((category) => category === tag) === -1) {
          categoryList.push(tag);
        }
      }
    }
  }

  return categoryList;
};

const getOpendayList = ({ list }) => {
  const opendayList = [];

  for (const goods of list) {
    if (goods.openday) {
      const day = new Date(goods.openday);
      const openYear = day.getFullYear();
      const openMonth = day.getMonth() + 1;

      if (
        opendayList.findIndex(
          (openday) => openday.year === openYear && openday.month === openMonth
        ) === -1
      ) {
        opendayList.push({ year: openYear, month: openMonth });
      }
    }
  }

  opendayList.sort((a, b) => {
    if (a.year === b.year) {
      return a.month - b.month;
    } else {
      return a.year - b.year;
    }
  });

  return opendayList;
};

const GoodsSwiper = ({ list, id, options = {} }) => {
  const [filteredList, setFilteredList] = useState(list);

  const { showNumber, showOpenDay, showCategoryFilter, showOpendayFilter } =
    options;

  const [categoryIndex, setCategoryIndex] = useState(-1);
  const [opendayIndex, setOpendayIndex] = useState(-1);

  const categoryList = getCategoryList({ list });
  const opendayList = getOpendayList({ list });

  useEffect(() => {
    if (opendayIndex === -1) {
      setFilteredList([...list]);
    } else {
      const tempList = [];

      for (const goods of list) {
        if (goods.openday) {
          const openday = new Date(goods.openday);

          const year = openday.getFullYear();
          const month = openday.getMonth() + 1;

          if (
            year === opendayList[opendayIndex].year &&
            month === opendayList[opendayIndex].month
          ) {
            tempList.push(goods);
          }
        }
      }

      setFilteredList(tempList);
    }
  }, [opendayIndex, list]);

  useEffect(() => {
    if (categoryIndex === -1) {
      setFilteredList([...list]);
    } else {
      const tempList = [];

      for (const goods of list) {
        if (goods.categoryTags) {
          const categoryTags = goods.categoryTags
            .split(',')
            .map((tag) => tag.trim());

          if (categoryTags.includes(categoryList[categoryIndex])) {
            tempList.push(goods);
          }
        }
      }

      setFilteredList(tempList);
    }
  }, [categoryIndex, list]);

  return (
    <>
      {/* {showCategoryFilter && (
        <div className="product_tab">
          <ul>
            <li>
              <a
                className={`${categoryIndex === -1 ? 'active' : ''}`}
                onClick={() => {
                  setCategoryIndex(-1);
                }}
              >
                전체
              </a>
            </li>
            {categoryList.map((category, index) => {
              return (
                <li key={`category-filter-${index}`}>
                  <a
                    className={`${categoryIndex === index ? 'active' : ''}`}
                    onClick={() => {
                      setCategoryIndex(index);
                    }}
                  >
                    {category}
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      )}
      {showOpendayFilter && (
        <div className="date_tab">
          <ul>
            <li>
              <a
                className={opendayIndex === -1 ? 'active' : ''}
                onClick={() => {
                  setOpendayIndex(-1);
                }}
              >
                전체
              </a>
            </li>
            {opendayList.map((openday, index) => {
              return (
                <li key={`openday-filter-${index}`}>
                  <a
                    className={opendayIndex === index ? 'active' : ''}
                    onClick={() => {
                      setOpendayIndex(index);
                    }}
                  >
                    {`${openday.year % 100}년 ${openday.month}월 발매`}
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      )} */}
      <div className="product_swiper_wp">
        <Swiper
          id="goods-swiper"
          className="product_swiper"
          modules={[Navigation, Pagination]}
          slidesPerView={'auto'}
          spaceBetween={8}
          navigation={{
            nextEl: `#goods-swiper-next-button-${id}`,
            prevEl: `#goods-swiper-prev-button-${id}`,
          }}
          breakpoints={{
            1280: {
              slidesPerView: 7,
            },
            769: {
              slidesPerView: 5,
            },
            481: {
              slidesPerView: 3,
            },
            0: {
              slidesPerView: 'auto',
            },
          }}
        >
          {filteredList.map((goods, index) => {
            return (
              <SwiperSlide key={`goods-swiper-slide-${id}-${goods.goodSerial}`}>
                <GoodsCard
                  goods={goods}
                  options={{
                    number: showNumber ? index + 1 : undefined,
                    showOpenDay,
                  }}
                />
              </SwiperSlide>
            );
          })}
        </Swiper>
        <div
          className="swiper-button-next"
          id={`goods-swiper-next-button-${id}`}
        />
        <div
          className="swiper-button-prev"
          id={`goods-swiper-prev-button-${id}`}
        />
      </div>
    </>
  );
};

export default GoodsSwiper;
